import { createRef, RefObject, useEffect, useRef, VideoHTMLAttributes } from "react";
import { HLS } from "@/components/UI/Player/hls";

interface HlsVideoProps
  extends VideoHTMLAttributes<HTMLVideoElement> {
  videoRef?: RefObject<HTMLVideoElement>;
  useHlsEngine?: boolean;
  onMounted?: () => void;
}

export const Player = ({
  videoRef = createRef<HTMLVideoElement>(),
  src = "",
  autoPlay = false,
  useHlsEngine = false,
  onMounted,
  ...restProps
}: HlsVideoProps) => {
  const hlsInstanceRef = useRef<HLS | null>(null);

  useEffect(() => {
    hlsInstanceRef.current?.destroy();

    if (!src || src.length === 0) {
      return;
    }

    if (videoRef.current) {
      if (useHlsEngine && HLS.isSupported()) {
        const hls = new HLS();
        hls.load(src, videoRef.current);
        hlsInstanceRef.current = hls;
      } else {
        videoRef.current.src = src;
      }
    }

    return () => {
      hlsInstanceRef.current?.destroy();
    };
  }, [src, videoRef]);

  useEffect(() => {
    onMounted && onMounted();
  }, []);

  return <video ref={videoRef} autoPlay={autoPlay} {...restProps} />;
};
